export default __webpack_public_path__ + "static/media/mobile2.f5a89f88.jfif";